import PrimaryMenu from './PrimaryMenu';

export default PrimaryMenu;
